import schema from '@/framework/logic/schema/merge-layout-property.schema.json';
import interpolate from '@/framework/logic/shared/interpolate';
import { makeValidated } from '@/framework/logic/shared/utils';

const mapMergeLayoutProperty = action => ({
  type: 'LAYOUT_MERGE',
  payload: {
    value: action.data.value,
    path: action.data.path,
  },
});

const mergeLayoutProperty = (context, event, meta) => {
  const validated = makeValidated(schema);
  return mapMergeLayoutProperty(
    validated(interpolate(meta.action, event, context))
  );
};

export default mergeLayoutProperty;
